// extracted by mini-css-extract-plugin
export default {"root":"table_root__rsYj4","header":"table_header__Mv3vN","row":"table_row__fve8Z","rowItem":"table_rowItem__ho2kj","loadMore":"table_loadMore__xGiH6"};